import {InfinityContext} from '../contexts/infinity.context';
import {useAssertedContext} from '../hooks/useAssertedContext';

export const useInfinityContext = () => useAssertedContext(InfinityContext);
